import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "flex items-center justify-between" }, [
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("h6", { class: "font-normal" }, " Penyesuaian Komisi Kurir ")
  ])
], -1)
const _hoisted_2 = { style: {"min-height":"70vh !important"} }
const _hoisted_3 = { class: "grid grid-cols-5 mb-5 gap-8" }
const _hoisted_4 = { class: " col-span-2" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "p-error" }
const _hoisted_7 = {
  key: 1,
  class: "p-error"
}
const _hoisted_8 = { class: " col-span-2" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "p-error" }
const _hoisted_11 = {
  key: 1,
  class: "p-error"
}
const _hoisted_12 = { class: "" }
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { class: "font-bold text-white" }, "Cari Kurir", -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "mt-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "m-auto" }, [
    /*#__PURE__*/_createVNode("p", { class: "color-blue-grey text-center font-bold" }, [
      /*#__PURE__*/_createTextVNode("Gunakan filter untuk "),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("Mengeluarkan data")
    ])
  ])
], -1)
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "font-bold" }
const _hoisted_19 = { class: "font-bold color-blue-grey" }
const _hoisted_20 = { class: "font-bold color-blue-grey" }
const _hoisted_21 = { class: "flex" }
const _hoisted_22 = /*#__PURE__*/_createVNode("p", { class: "text-sm color-blue-grey font-bold" }, "Penyesuaian", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "pi pi-angle-right text-sm color-blue-grey font-bold" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_Button = _resolveComponent("Button")
  const _component_ListBlankCourier = _resolveComponent("ListBlankCourier")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")
  const _component_ComissionAdjustmentModal = _resolveComponent("ComissionAdjustmentModal")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Card, { class: "" }, {
      title: _withCtx(() => [
        _hoisted_1
      ]),
      content: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_InputText, {
                placeholder: "Ketik Nama Kurir",
                class: "input-grey w-full rounded-lg",
                modelValue: $setup.v$.inputCourier.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.v$.inputCourier.$model = $event)),
                style: {"border":"none !important"}
              }, null, 8, ["modelValue"]),
              ($setup.v$.inputCourier.$error && $setup.submitted)
                ? (_openBlock(), _createBlock("span", _hoisted_5, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.v$.inputCourier.$errors, (error, index) => {
                      return (_openBlock(), _createBlock("span", {
                        id: "new-inputCourier-error",
                        key: index
                      }, [
                        _createVNode("small", _hoisted_6, _toDisplayString(error.$message), 1)
                      ]))
                    }), 128))
                  ]))
                : (($setup.v$.inputCourier.$invalid && $setup.submitted) || $setup.v$.inputCourier.$pending.$response)
                  ? (_openBlock(), _createBlock("small", _hoisted_7, _toDisplayString($setup.v$.inputCourier.required.$message), 1))
                  : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_Multiselect, {
                class: "input-grey can-not-empty no-border cursor-pointer rounded-lg",
                modelValue: $setup.v$.inputAgent.$model,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.v$.inputAgent.$model = $event)),
                placeholder: "Pilih Agen",
                options: $setup.agentOptions,
                "close-on-select": false,
                "show-labels": false,
                searchable: true,
                "allow-empty": false,
                label: "label",
                "track-by": "label",
                "hide-selected": true
              }, null, 8, ["modelValue", "options"]),
              ($setup.v$.inputAgent.$error && $setup.submitted)
                ? (_openBlock(), _createBlock("span", _hoisted_9, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.v$.inputAgent.$errors, (error, index) => {
                      return (_openBlock(), _createBlock("span", {
                        id: "new-inputAgent-error",
                        key: index
                      }, [
                        _createVNode("small", _hoisted_10, _toDisplayString(error.$message), 1)
                      ]))
                    }), 128))
                  ]))
                : (($setup.v$.inputAgent.$invalid && $setup.submitted) || $setup.v$.inputAgent.$pending.$response)
                  ? (_openBlock(), _createBlock("small", _hoisted_11, _toDisplayString($setup.v$.inputAgent.required.$message), 1))
                  : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode(_component_Button, {
                class: "btn-primary p-button-sm rounded-md w-full flex justify-center gap-2",
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.searchData(!$setup.v$.$invalid)))
              }, {
                default: _withCtx(() => [
                  _hoisted_13,
                  _hoisted_14
                ]),
                _: 1
              })
            ])
          ]),
          (!$setup.isShowTable)
            ? (_openBlock(), _createBlock("div", _hoisted_15, [
                _createVNode(_component_ListBlankCourier),
                _hoisted_16
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_17, [
                _createVNode(_component_DataTable, {
                  value: $setup.dataAdjustment,
                  paginator: false,
                  stripedRows: "",
                  class: "table-og",
                  responsiveLayout: "scroll"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      header: "Nama Kurir",
                      style: {"min-width":"150px !important"}
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("p", _hoisted_18, _toDisplayString(slotProps.data?.Fullname), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      header: "Agen",
                      style: {"min-width":"50px"}
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("p", _hoisted_19, _toDisplayString(slotProps.data?.Agen), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      header: "No. Telp",
                      style: {"min-width":"50px"}
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("p", {
                          class: "font-bold color-blue-grey hover-primary cursor-pointer",
                          onClick: ($event: any) => (_ctx.$goWhatsApps(slotProps.data.Phonenumber))
                        }, _toDisplayString(slotProps.data.Phonenumber), 9, ["onClick"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      header: "Saldo Saat Ini",
                      style: {"min-width":"50px"}
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("p", _hoisted_20, _toDisplayString(`Rp. ${new Number(slotProps.data?.Saldo).toLocaleString('id-ID')}`), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      header: "",
                      style: {"min-width":"50px"}
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("div", _hoisted_21, [
                          _createVNode("div", {
                            class: "rounded-md gap-2 py-1 px-3 cursor-pointer flex items-center",
                            onClick: ($event: any) => ($setup.customizeData(slotProps.data)),
                            style: {"box-shadow":"0px 2px 12px rgba(0, 0, 0, 0.12)"}
                          }, [
                            _hoisted_22,
                            _hoisted_23
                          ], 8, ["onClick"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]))
        ])
      ]),
      footer: _withCtx(() => []),
      _: 1
    }),
    ($setup.isShowDialog)
      ? (_openBlock(), _createBlock(_component_ComissionAdjustmentModal, {
          key: 0,
          isShowDialog: $setup.isShowDialog,
          onHideDialog: $setup.hideDialog,
          onReloadData: $setup.reloadData,
          dataForm: $setup.dataFormAdjustment
        }, null, 8, ["isShowDialog", "onHideDialog", "onReloadData", "dataForm"]))
      : _createCommentVNode("", true)
  ]))
}